import React from 'react';
import { Form, Radio } from 'tea-component';
import { useIntl } from 'umi';
import { GPTType } from '../../types';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import { AiIconMap, AIModalType } from '../../constants';
import classnames from 'classnames';

type AgentOptionsProps = {
  label?: string;
  gptType: GPTType;
  setGptType: (value: GPTType) => void;
  hasAgent?: boolean;
  options?: { value: AIModalType; text: string }[];
};

const defaultOptions: { value: AIModalType; text: string }[] = [
  { value: 'gpt', text: 'ChatGPT' },
  { value: 'deepseek', text: 'DeepSeek' },
];

export function AgentOptions({
  gptType,
  setGptType,
  options = defaultOptions,
}: Omit<AgentOptionsProps, 'hasAgent'>) {
  return (
    <Radio.Group
      value={gptType}
      onChange={(value: any) => {
        buriedBtnPoint('GPT_Agent', value);
        setGptType(value);
      }}
    >
      {options.map((item) => {
        return (
          <Radio
            key={item.value}
            name={item.value}
            className={classnames('radio-item', {
              'dbo-active': item.value === gptType,
            })}
          >
            <img src={AiIconMap[item.value]} className="dbo-radio-item-icon" />
            {item.text}
          </Radio>
        );
      })}
    </Radio.Group>
  );
}

export function AgentOptionsForm({
  hasAgent = true,
  label = 'Agent',
  ...props
}: AgentOptionsProps) {
  const { formatMessage } = useIntl();
  if (!hasAgent) return null;
  return (
    <Form.Item
      label={formatMessage({ id: label })}
      className="dbo-aigc-radio-wrapper"
    >
      <AgentOptions {...props}></AgentOptions>
    </Form.Item>
  );
}
